import * as Factory from 'factory.ts'
import faker from 'faker'

import type { Components } from '@webapp/api/integrations/client'
import { IntegrationEntities } from '@webapp/models/enums/IntegrationEntity'

export const VendorSyncConfigurationStub =
  Factory.Sync.makeFactory<Components.Schemas.EntitySyncConfigurationResponse>({
    id: Factory.each(() => faker.random.uuid()),
    entity: IntegrationEntities.VENDOR,
    is_enabled: true,
    last_sync: null,
  })

export const AccountSyncConfigurationStub =
  Factory.Sync.makeFactory<Components.Schemas.EntitySyncConfigurationResponse>({
    id: Factory.each(() => faker.random.uuid()),
    entity: IntegrationEntities.ACCOUNT_CODE,
    is_enabled: true,
    last_sync: null,
  })

export const EntitySyncConfigurationStub =
  Factory.Sync.makeFactory<Components.Schemas.EntitySyncConfigurationResponse>({
    id: Factory.each(() => faker.random.uuid()),
    entity: IntegrationEntities.ACCOUNT_CODE,
    is_enabled: false,
    last_sync: null,
  })

export const EntitySyncConfigurationsStub = [
  VendorSyncConfigurationStub.build(),
  AccountSyncConfigurationStub.build(),
]

export const PaymentSyncConfigurationStub =
  Factory.Sync.makeFactory<Components.Schemas.EntitySyncConfigurationResponse>({
    id: Factory.each(() => faker.random.uuid()),
    entity: IntegrationEntities.PAYMENT,
    is_enabled: true,
    last_sync: null,
  })
